"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { type UseFormProps, useForm } from "react-hook-form";
import type { TypeOf, ZodSchema, z } from "zod";

interface UseZodFormProps<Z extends ZodSchema>
	extends Exclude<UseFormProps<TypeOf<Z>>, "resolver"> {
	schema: Z;
}

export const useZodForm = <Z extends ZodSchema>({ schema, ...formProps }: UseZodFormProps<Z>) => {
	return useForm<z.input<typeof schema>, unknown, z.output<typeof schema>>({
		...formProps,
		resolver: async (data, context, options) => {
			console.info("formData", data);
			console.info("validation result", await zodResolver(schema)(data, context, options));

			return zodResolver(schema)(data, context, options);
		},
	});
};
